import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { prependAccountSlug } from '../../../util/account';
import Angle from '../../../components/global/Angle';

class WebGalleryFavoritePhotosToolbar extends Component {
  static propTypes = {
    folder: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
    album: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
    }),
  };

  render() {
    const { folder, album } = this.props;

    if (!folder && !album) {
      return null;
    }

    const link = folder
      ? prependAccountSlug(`/galleries/view/folder/${folder.id}`, folder)
      : prependAccountSlug(`/galleries/view/album/${album.id}`, album);

    return (
      <div className="wg-favorites-toolbar toolbar sticky-top">
        <span className="toolbar-title toolbar-title-fullwidth">
          <Link to={link} className="d-inline-flex btn-body-back">
            <Angle direction="left" className="mr-1" /> Back
          </Link>
        </span>
      </div>
    );
  }
}

export default WebGalleryFavoritePhotosToolbar;
